import http from "../../utils/http"

/**
 * เข้า สู่ ระบบ
 */
export function login(params) {
    return http({
        url: "/api/login/login",
        data: params
    })
}

/**
 * เข้าสู่ระบบด้วยหมายเลขโทรศัพท์ของคุณ
 * @param json params
 */
export function mobile_login(params) {
    return http({
        url: "/api/login/mobile",
        data: params
    })
}

/**
 * รับรหัสแบบไดนามิกของ SMS
 */
export function mobileCode(params) {
    return http({
        url: "/api/login/mobileCode",
        data: params
    })
}

/**
 * รีเซ็ตรหัสผ่านของคุณ
 */
export function rePass(params) {
    return http({
        url: "/api/findpassword/mobile",
        data: params
    })
}

/**
 * ต่อไป
 */
export function nextStep(params) {
    return http(
        {
            url: "/api/member/checkmobile",
            data: params
        },
        -1
    )
}

/**
 * รับรหัสแบบไดนามิกของ SMS
 */
export function smsCode(params) {
    return http({
        url: "/api/findpassword/mobilecode",
        data: params
    })
}

/**
 * รับการกําหนดค่าการลงทะเบียน
 */
export function registerConfig(params) {
    return http({
        url: "/api/register/config",
        data: params
    })
}

/**
 * รับรหัสแบบไดนามิกของ WeChat ที่มีผลผูกพัน SMS ไปยัง SMS โทรศัพท์มือถือ
 */
export function wechatMobileCode(params) {
    return http({
        url: "/api/login/getMobileCode",
        data: params
    })
}